const store = {
  namespaced: true,
  state: {
    storeList: [],
    storeData: JSON.parse(localStorage.getItem("se_store_data") || "{}") // 当前门店详情
  },
  getters: {},
  mutations: {
    setStoreList(state, data) {
      state.storeList = data;
    },
    setStoreData(state, data) {
      state.storeData = data;
      localStorage.setItem("se_store_data", JSON.stringify(data));
    }
  },
  actions: {
    async getStoreList({ rootState, commit }, params = {}) {
      const data = await rootState.http("/store/queryStoreList", params);
      commit("setStoreList", data.data.list || []);
      return data;
    },
    async getStoreInfo({ rootState, commit }, params = {}) {
      const data = await rootState.http("store/getStoreInfo", params);
      data.data && commit("setStoreData", data.data);
      return data;
    },
    async deleteStoreData({ rootState }, params = {}) {
      const data = await rootState.http("/store/clearStoreData", params);
      return data;
    }
  }
};

export default store;
